module.exports = __webpack_public_path__ + "be5322b31548869d6973f6fad855dca4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/flower-tulip-s.png
// module id = 2524
// module chunks = 0